import reports from './domains/reports';
import dashboard from './domains/dashboard';
import food from './domains/food';
import labor from './domains/labor';
import cash from './domains/cash';
import service from './domains/service';
import shift from './domains/shift';
import people from './domains/people';
import digital from './domains/digital';
import payroll from './domains/payroll';
import sales from './domains/sales';
import commsHub from './domains/commsHub';
import dashboardTooltips from './domains/dashboardTooltips';
import product from './domains/product';
import dayparts from './domains/dayparts';

// Single source of truth for the locales the domain translations ship.
//
// Codes are lowercase and hyphenated to match myq-core, which lowercases
// `user.language` before handing it to `setLocale` and keys its own regional
// locales the same way (`en-gb`, `es-mx`). Anything merging domain messages
// into vue-i18n should iterate this list rather than hardcoding the codes, so
// adding a language stays a one-line change here plus a block per domain file.
export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'fr-ca'];

const domains = [reports, dashboard, food, labor, cash, service, people, digital, shift, dayparts, payroll, sales, commsHub, product, dashboardTooltips];

const merged = Object.fromEntries(SUPPORTED_LOCALES.map((locale) => [locale, {}]));

for (const domain of domains) {
  for (const locale of SUPPORTED_LOCALES) {
    Object.assign(merged[locale], domain[locale]);
  }
}

export default merged;
